import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "../styles/AddVideo.css";

export default function AddVideo() {
  const navigate = useNavigate();
  const [videoFile, setVideoFile] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);
  const [uploading, setUploading] = useState(false);
  const videoRef = useRef();

  // Handle file select and preview
  const handleVideoSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 60 * 1024 * 1024) {
        alert("Please select a video under 60MB.");
        return;
      }

      const url = URL.createObjectURL(file);
      setPreviewURL(url);
      setVideoFile(file);
    }
  };

  // Upload to Cloudinary
  const handleUpload = async () => {
    if (!videoFile) {
      alert("Please select a video first.");
      return;
    }

    setUploading(true);

    const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
    const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

    const formData = new FormData();
    formData.append("file", videoFile);
    formData.append("upload_preset", uploadPreset);
    formData.append("resource_type", "video");

    try {
      const res = await fetch(
        `https://api.cloudinary.com/v1_1/${cloudName}/video/upload`,
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await res.json();

      if (data.secure_url) {
        // Save metadata to Firestore
        await addDoc(collection(db, "videos"), {
          videoUrl: data.secure_url,
          username: "Eyal Mart", // Replace with logged-in user later
          timestamp: serverTimestamp(),
        });

        alert("✅ Video uploaded successfully!");
        navigate("/videos");
      } else {
        alert("Upload failed. Please try again.");
      }
    } catch (err) {
      console.error("Error uploading video:", err);
      alert("Error uploading video.");
    }

    setUploading(false);
  };

  return (
    <div className="add-video-container">
      <h2 className="add-video-title">🎬 Add New Video</h2>

      {!previewURL ? (
        // ✅ Full clickable box
        <div
          className="upload-box"
          onClick={() => document.getElementById("videoUpload").click()}
        >
          <span className="upload-label">📹 Select Video (≤ 60s)</span>
          <input
            id="videoUpload"
            type="file"
            accept="video/*"
            onChange={handleVideoSelect}
            hidden
          />
        </div>
      ) : (
        <div className="preview-section">
          <video
            ref={videoRef}
            src={previewURL}
            controls
            loop
            className="preview-player"
          />
          <div className="preview-actions">
            <button
              className="reselect-btn"
              onClick={() => {
                setPreviewURL(null);
                setVideoFile(null);
              }}
              disabled={uploading}
            >
              Change
            </button>
            <button
              className="upload-btn"
              onClick={handleUpload}
              disabled={uploading}
            >
              {uploading ? "Uploading..." : "Upload"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
